import { storageService } from "@/services/storageService";

/** Collect managed R2 URLs from CrudModule field definitions on a row. */
export function collectR2UrlsFromRow(row, fields = []) {
  const urls = [];
  for (const field of fields) {
    const value = row?.[field.name];
    if (field.type === "image" && value) {
      urls.push(value);
    } else if (field.type === "gallery" && Array.isArray(value)) {
      urls.push(...value);
    }
  }
  return urls.filter((url) => storageService.isManagedR2Url(url));
}

/** URLs present on the old row but not on the updated row (same field set). */
export function findRemovedR2Urls(oldRow, newRow, fields = []) {
  const before = new Set(collectR2UrlsFromRow(oldRow, fields));
  const after = new Set(collectR2UrlsFromRow(newRow, fields));
  return [...before].filter((url) => !after.has(url));
}
